import { supabase } from "../supabase";

export async function getBarDelFeeById(id) {
  const { data, error } = await supabase
    .from("delivery_fees    ")
    .select("*")
    .eq("id", id)
    .maybeSingle();

  if (error) {
    console.log(error);
    throw error;
  }

  return data;
}
